import { __extends } from 'tslib';
import * as React from 'react';
import { UitkIcon } from 'uitk-react-icons';
import { classNames, UitkContextWrapper } from 'uitk-react-utils';
import styles from './uitk-switch.css';

var getClassNameList = classNames.bind(styles);
var UitkSwitch = /** @class */ (function (_super) {
    __extends(UitkSwitch, _super);
    function UitkSwitch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkSwitch.prototype.render = function () {
        var _a;
        var _b = this.props, a11yLabel = _b.a11yLabel, checked = _b.checked, children = _b.children, className = _b.className, disabled = _b.disabled, description = _b.description, errorMessage = _b.errorMessage, id = _b.id, label = _b.label, labelClassName = _b.labelClassName, name = _b.name, onChange = _b.onChange, required = _b.required, switchPosition = _b.switchPosition, _c = _b.theme, theme = _c === void 0 ? 'standard' : _c, value = _b.value;
        var baseCssClass = 'uitk-switch';
        var wrapperClassNames = getClassNameList(baseCssClass, className, "".concat(baseCssClass, "-theme-").concat(theme), "".concat(baseCssClass, "-position-").concat(switchPosition), {
            'is-disabled': disabled
        });
        var labelCssClassNames = getClassNameList("uitk-switch-label", (_a = {},
            _a[labelClassName] = Boolean(labelClassName),
            _a['is-required'] = required,
            _a));
        var inputClassNames = getClassNameList("".concat(baseCssClass, "-input"), {
            checked: checked
        });
        var controlClassNames = getClassNameList("".concat(baseCssClass, "-control"));
        var handleClassNames = getClassNameList("".concat(baseCssClass, "-control-handle"));
        var contentClassNames = getClassNameList("".concat(baseCssClass, "-content"));
        var labelContentClassNames = getClassNameList("".concat(baseCssClass, "-label-content"));
        var descriptionClassNames = getClassNameList("".concat(baseCssClass, "-description"));
        var errorClassNames = getClassNameList("".concat(baseCssClass, "-error"));
        var contents = label || children;
        var a11yContent = a11yLabel !== null && a11yLabel !== void 0 ? a11yLabel : contents === null || contents === void 0 ? void 0 : contents.toString();
        var a11yFullLabel = description ? "".concat(a11yContent, " ").concat(description) : a11yContent;
        return (React.createElement(UitkContextWrapper, null, function (context, data) { return (React.createElement("div", { className: wrapperClassNames },
            React.createElement("input", { type: "checkbox", name: name || id, id: id, checked: checked, className: inputClassNames, onChange: onChange, value: value, "aria-invalid": errorMessage ? true : undefined, disabled: disabled, "aria-required": required, "aria-label": a11yFullLabel }),
            React.createElement("div", { "aria-hidden": "true", className: controlClassNames },
                React.createElement("div", { className: handleClassNames },
                    React.createElement(UitkIcon, { name: checked ? 'check' : 'close' }))),
            React.createElement("div", { className: contentClassNames },
                React.createElement("label", { className: labelCssClassNames, htmlFor: id },
                    React.createElement("span", { className: labelContentClassNames },
                        contents,
                        required && (data === null || data === void 0 ? void 0 : data.hasRequiredFieldIndicator) && (React.createElement("span", { className: "uitk-switch-required-asterisk", "aria-hidden": "true" },
                            ' ',
                            "*"))),
                    description && React.createElement("p", { className: descriptionClassNames }, description)),
                errorMessage && React.createElement("p", { className: errorClassNames }, errorMessage)))); }));
    };
    UitkSwitch.displayName = 'UitkSwitch';
    UitkSwitch.defaultProps = {
        checked: false,
        switchPosition: 'leading'
    };
    return UitkSwitch;
}(React.Component));

export { UitkSwitch };
